<app-ds-autocomplete
	class="user-search"
	[label]="label"
	[placeholder]="placeholder"
	[disabled]="disabled"
	[options]="users || []"
	[displayWith]="displayFn"
	[filterWith]="filterFn"
	[optionTpl]="usOptTpl"
	[prefixTpl]="current ? usPrefixTpl : null"
	[suffixTpl]="tooltip ? usSuffixTpl : null"
	[maxOptions]="MAX_RESULTS"
	[moreText]="moreTextFn"
	[noResults]="'userSearch.noResults' | translate"
	[value]="current"
	(valueChange)="onValueChange($event)"
	(cleared)="onCleared()"
	(touched)="onTouched()"
></app-ds-autocomplete>

<!-- Prefijo del campo: avatar (foto EntraID / iniciales) de la persona seleccionada. -->
<ng-template #usPrefixTpl>
	<app-empleado-avatar [empleado]="current" size="sm"></app-empleado-avatar>
</ng-template>

<!-- Sufijo del campo: icono info con tooltip (como los formularios de detalle). -->
<ng-template #usSuffixTpl>
	<mat-icon [matTooltip]="tooltip">info</mat-icon>
</ng-template>

<!-- Fila rica del desplegable: avatar con foto + nombre + email/función. -->
<ng-template #usOptTpl let-u>
	<div class="us-option">
		<app-empleado-avatar [empleado]="u"></app-empleado-avatar>
		<span class="us-text">
			<span class="us-name" [class.us-name--noname]="!hasName(u)">{{ name(u) }}</span>
			<span class="us-meta">
				{{ u.email
				}}<ng-container *ngIf="u.funcionAgregada"> · {{ u.funcionAgregada }}</ng-container>
			</span>
		</span>
	</div>
</ng-template>
